import { render, staticRenderFns } from "./tempTextModel.vue?vue&type=template&id=4d724e50&lang=pug&"
import script from "./tempTextModel.vue?vue&type=script&lang=js&"
export * from "./tempTextModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports